import { callAxios, dev_console, whoAmI } from "../ts/commonTools";
import { userInfoData_Interface } from "../interface/userInfoDataREST.interface";
import useCustomQuery from "./useCustomQuery";

const useUserInfoDataREST = () => {
    const isAbleToRequest = () => {
        let result: boolean = false;

        if(whoAmI.isAllEnAbleUser()){
            result = true;
        }

        return result;
    }

    const {
        data: userInfoData = null,
        error: userInfoDataError,
        isLoading: isUserInfoDataLoading,
        refetch: userInfoDataRefetch,
    } = useCustomQuery({
        queryKey: ["userInfoData"],
        queryFn: getMypageData,
        enabled: isAbleToRequest,
        select: (response) => {
            if (response.status === 200 && response.data.msg === "success") {
                const data: userInfoData_Interface = response.data.data;
                return data;
            }else{
                return null;
            }
        },
    })

    // 유저 개인 정보를 호출하는 함수
    async function getMypageData(){
        const mypage_url = "api/v3/customers/mypage";

        const response = await callAxios.api({
            url: mypage_url,
            method: "get",
        })

        dev_console.log(mypage_url);
        dev_console.log(response);

        return response;
    }

    return{
        userInfoData,
        userInfoDataError,
        isUserInfoDataLoading,
        userInfoDataRefetch,
    }
}

export default useUserInfoDataREST;